// import { useState, useEffect } from "react";
// import { SubmitButton } from "../../components/Input";
// import { useNavigate, useParams } from "react-router-dom";
// import StateManagedSelect from "react-select";
// import { API_URL } from "../../config";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { showToast } from "../../components/toast";

// const fieldList = [
//   { value: "", label: "- Select -" },
//   { value: "$buysell", label: "BUY/SELL" },
//   { value: "$service_name", label: "Service Name" },
//   { value: "$symbol", label: "Symbol" },
//   { value: "$duration", label: "Duration" },
//   { value: "$quantity", label: "Quantity" },
//   { value: "$entry_price", label: "Entry Price" },
//   { value: "$target1", label: "Target 1" },
//   { value: "$target2", label: "Target 2" },
//   { value: "$stoploss", label: "StopLoss" },
//   { value: "$profit", label: "Profit" },
//   { value: "$dated", label: "Dated" },
//   { value: "$cmp", label: "Current Market Price" },
//   { value: "$comments", label: "Comments" },
//   {
//     value: "$saveonpage",
//     label:
//       "Save On Page String Ex. TGT1 Modified to Price / TGT2 Modified to Price / Stoploss Modified to Price",
//   },
//   { value: "$tradenowurl", label: "Trade Now Url" },
// ];

// const TemplateResearchForm = () => {
//   const { id } = useParams();
//   const [templateName, setTemplateName] = useState("");
//   const [message, setMessage] = useState("");
//   const [notificationTitle, setNotificationTitle] = useState("");
//   const [notification, setNotification] = useState("");
//   const [whatsappCampaign, setWhatsappCampaign] = useState("");
//   const [templateType, setTemplateType] = useState("1");
//   const [wpFileName, setWpFileName] = useState("");
//   const [file, setFile] = useState(null);
//   const [oldFileUrl, setOldFileUrl] = useState("");
//   const [paramList, setParamList] = useState([]);
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);
//   const token = localStorage.getItem("authToken");

//   const typeArr = { 1: "Text", 2: "Image", 3: "Video", 4: "File" };

//   useEffect(() => {
//     if (id) fetchTemplateData(id);
//   }, [id]);

//   const fetchTemplateData = async (id) => {
//     try {
//       setLoading(true);
//       const response = await axios.get(
//         `${API_URL}settings/research/template/${id}`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       const data = response.data.data;
//       setTemplateName(data.templateName);
//       setMessage(data.message);
//       setNotificationTitle(data.notificationTitle);
//       setNotification(data.notification);
//       setWhatsappCampaign(data.whatsappCampaign);
//       setTemplateType(data.templateType.toString());
//       setWpFileName(data.fileName);
//       setOldFileUrl(data.fileUrl);
//       if (data.whatsapp) {
//         const list = data.whatsapp.split(",").map((val) => {
//           const found = fieldList.find((field) => field.value === val);
//           return found || { value: val, label: val };
//         });
//         setParamList(list);
//       }
//     } catch (error) {
//       console.error("Error fetching templates:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAddData = () => {
//     setParamList([...paramList, { value: "", label: "- Select -" }]);
//   };

//   const handleDeleteRow = (index) => {
//     const updatedParams = [...paramList];
//     updatedParams.splice(index, 1);
//     setParamList(updatedParams);
//   };

//   const handleParamChange = (selectedOption, index) => {
//     const updatedParams = [...paramList];
//     updatedParams[index] = selectedOption;
//     setParamList(updatedParams);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const payload = {
//       templateName: templateName,
//       message: message,
//       notification: notification,
//       notificationTitle: notificationTitle,
//       whatsapp: paramList.map((param) => param.value).join(","),
//       whatsappCampaign: whatsappCampaign,
//       templateType: templateType,
//       fileName: wpFileName,
//       file_url: file,
//     };

//     try {
//       const config = {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "multipart/form-data",
//         },
//       };

//       const url = id
//         ? `${API_URL}settings/research/template/save?id=${id}`
//         : `${API_URL}settings/research/template/save`;

//       const response = await axios.post(url, payload, config);

//       if (response.data.success) {
//         showToast.success(response.data.message);
//         navigate("/Settings/TemplateResearch"); // Optional redirect
//       }
//     } catch (error) {
//       console.error("Error saving template:", error);
//       showToast.error("There was an error saving the template");
//     }
//   };

//   const handleFieldChange = (e, fieldName) => {
//     const value = e.target.value;
//     switch (fieldName) {
//       case "templateName":
//         setTemplateName(value);
//         break;
//       case "message":
//         setMessage(value);
//         break;
//       case "notificationTitle":
//         setNotificationTitle(value);
//         break;
//       case "notification":
//         setNotification(value);
//         break;
//       case "whatsappCampaign":
//         setWhatsappCampaign(value);
//         break;
//       case "templateType":
//         setTemplateType(value);
//         break;
//       case "wpFileName":
//         setWpFileName(value);
//         break;
//       default:
//         break;
//     }
//   };

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <div className="page-container page-header-fixed page-sidebar-fixed fade in mt-5">
//       <div className="panel panel-default with-rounded-corner with-shadow">
//         <form onSubmit={handleSubmit} encType="multipart/form-data">
//           <div className="panel-heading border-0">
//             <span className="panel-title">
//               {id ? "Edit" : "Add"} Template Research
//             </span>
//           </div>
//           <div className="panel-body">
//             <div className="row">
//               <div className="col-md-4 mb-2">
//                 <label>Template Name</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="templateName"
//                   value={templateName}
//                   onChange={(e) => handleFieldChange(e, "templateName")}
//                   disabled
//                 />
//               </div>

//               <div className="col-md-8 mb-2">
//                 <label>Select Data (Message)</label>
//                 <StateManagedSelect
//                   options={fieldList}
//                   onChange={(option) =>
//                     option && setMessage((prev) => prev + option.value)
//                   }
//                 />
//               </div>

//               <div className="col-md-12 mb-2">
//                 <label>Message</label>
//                 <textarea
//                   className="form-control"
//                   name="message"
//                   value={message}
//                   onChange={(e) => handleFieldChange(e, "message")}
//                 />
//               </div>

//               <div className="col-md-8 mb-2">
//                 <label>Select Data (Notification Title)</label>
//                 <StateManagedSelect
//                   options={fieldList}
//                   onChange={(option) =>
//                     option &&
//                     setNotificationTitle((prev) => prev + option.value)
//                   }
//                 />
//               </div>

//               <div className="col-md-12 mb-2">
//                 <label>Push Notification Title</label>
//                 <textarea
//                   className="form-control"
//                   name="notificationTitle"
//                   value={notificationTitle}
//                   onChange={(e) => handleFieldChange(e, "notificationTitle")}
//                 />
//               </div>

//               <div className="col-md-8 mb-2">
//                 <label>Select Data (Notification)</label>
//                 <StateManagedSelect
//                   options={fieldList}
//                   onChange={(option) =>
//                     option && setNotification((prev) => prev + option.value)
//                   }
//                 />
//               </div>

//               <div className="col-md-12 mb-2">
//                 <label>Push Notification</label>
//                 <textarea
//                   className="form-control"
//                   name="notification"
//                   value={notification}
//                   onChange={(e) => handleFieldChange(e, "notification")}
//                 />
//               </div>

//               <div className="col-md-4 mb-2">
//                 <label>Campaign Name</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="whatsappCampaign"
//                   value={whatsappCampaign}
//                   onChange={(e) => handleFieldChange(e, "whatsappCampaign")}
//                 />
//               </div>

//               <div className="col-md-5 mb-2">
//                 <label>Template Type</label>
//                 <select
//                   className="form-control"
//                   name="templateType"
//                   value={templateType}
//                   onChange={(e) => handleFieldChange(e, "templateType")}
//                 >
//                   {Object.entries(typeArr).map(([key, value]) => (
//                     <option key={key} value={key}>
//                       {value}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               {templateType !== "1" && (
//                 <div className="row w-100 d-flex gap-2 align-items-end">
//                   <div className="col-md-4 mb-2">
//                     <label>File Name</label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="wpFileName"
//                       value={wpFileName}
//                       onChange={(e) => handleFieldChange(e, "wpFileName")}
//                     />
//                   </div>
//                   <div className="col-md-5 mb-2">
//                     <label>Upload File</label>
//                     <input
//                       type="file"
//                       name="wp_upload_file"
//                       className="form-control"
//                       onChange={(e) => setFile(e.target.files[0])}
//                     />
//                   </div>
//                   {oldFileUrl && (
//                     <div className="col-md-3">
//                       <img src={oldFileUrl} alt="File Preview" width="50px" />
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>

//             <div className="row">
//               <table className="table">
//                 <thead>
//                   <tr>
//                     <th style={{ width: "70%" }}>Field</th>
//                     <th style={{ width: "30%" }}>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {paramList.map((param, index) => (
//                     <tr key={index}>
//                       <td>
//                         <StateManagedSelect
//                           options={fieldList}
//                           value={param}
//                           onChange={(selectedOption) =>
//                             handleParamChange(selectedOption, index)
//                           }
//                         />
//                       </td>
//                       <td>
//                         <button
//                           type="button"
//                           className="btn btn-danger"
//                           onClick={() => handleDeleteRow(index)}
//                         >
//                           <i className="fa fa-times" /> Delete
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                   <tr>
//                     <td colSpan="2">
//                       <button
//                         type="button"
//                         className="btn btn-success"
//                         onClick={handleAddData}
//                       >
//                         + Add Field
//                       </button>
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>

//             <div className="col-md-12">
//               <SubmitButton
//                 pageBack={"/Settings/TemplateResearch"}
//                 handleSubmit={handleSubmit}
//               />
//             </div>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default TemplateResearchForm;


import { useState, useEffect } from "react";
import { SubmitButton } from "../../components/Input";
import { useNavigate, useParams } from "react-router-dom";
import StateManagedSelect from "react-select";
import { API_URL } from "../../config";
import axios from "axios";
import { showToast } from "../../components/toast";
import LoadingSpinner from "../../components/LoadingSpinner";

const fieldList = [
  { value: "", label: "- Select -" },
  { value: "$buysell", label: "BUY/SELL" },
  { value: "$service_name", label: "Service Name" },
  { value: "$symbol", label: "Symbol" },
  { value: "$duration", label: "Duration" },
  { value: "$quantity", label: "Quantity" },
  { value: "$entry_price", label: "Entry Price" },
  { value: "$target1", label: "Target 1" },
  { value: "$target2", label: "Target 2" },
  { value: "$stoploss", label: "StopLoss" },
  { value: "$profit", label: "Profit" },
  { value: "$dated", label: "Dated" },
  { value: "$cmp", label: "Current Market Price" },
  { value: "$comments", label: "Comments" },
  {
    value: "$saveonpage",
    label:
      "Save On Page String Ex. TGT1 Modified to Price / TGT2 Modified to Price / Stoploss Modified to Price",
  },
  { value: "$tradenowurl", label: "Trade Now Url" },
];

const TemplateResearchForm = () => {
  const { id } = useParams();
  const [templateName, setTemplateName] = useState("");
  const [message, setMessage] = useState("");
  const [notificationTitle, setNotificationTitle] = useState("");
  const [notification, setNotification] = useState("");
  const [whatsappCampaign, setWhatsappCampaign] = useState("");
  const [templateType, setTemplateType] = useState("1");
  const [wpFileName, setWpFileName] = useState("");
  const [file, setFile] = useState(null);
  const [oldFileUrl, setOldFileUrl] = useState("");
  const [paramList, setParamList] = useState([]);
  const [imageFile, setImageFile] = useState(null);
  const [oldImageUrl, setOldImageUrl] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("authToken");

  const typeArr = { 1: "Text", 2: "Image", 3: "Video", 4: "File" };

  useEffect(() => {
    if (id) fetchTemplateData(id);
  }, [id]);

  const fetchTemplateData = async (id) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_URL}settings/research/template/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const data = response.data.data;
      setTemplateName(data.template_name);
      setMessage(data.message);
      setNotificationTitle(data.notification_title);
      setNotification(data.notification);
      setWhatsappCampaign(data.whatsapp_campaign);
      setTemplateType(data.template_type.toString());
      setWpFileName(data.file_name);
      setOldFileUrl(data.file_url);
      setOldImageUrl(data.template_push_file_url || ""); // ✅ set old image URL if exists

      if (data.whatsapp) {
        const list = data.whatsapp.split(",").map((val) => {
          const found = fieldList.find((field) => field.value === val);
          return found || { value: val, label: val };
        });
        setParamList(list);
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddData = () => {
    setParamList([...paramList, { value: "", label: "- Select -" }]);
  };

  const handleDeleteRow = (index) => {
    const updatedParams = [...paramList];
    updatedParams.splice(index, 1);
    setParamList(updatedParams);
  };

  const handleParamChange = (selectedOption, index) => {
    const updatedParams = [...paramList];
    updatedParams[index] = selectedOption;
    setParamList(updatedParams);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("templateName", templateName);
    formData.append("message", message);
    formData.append("notification", notification);
    formData.append("notificationTitle", notificationTitle);
    formData.append(
      "whatsapp",
      paramList.map((param) => param.value).join(",")
    );
    formData.append("whatsappCampaign", whatsappCampaign);
    formData.append("templateType", templateType);
    formData.append("fileName", wpFileName);

    if (file) formData.append("file_url", file);
    if (imageFile) formData.append("tp_upload_file", imageFile); // ✅ include image file

    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      };

      const url = id
        ? `${API_URL}settings/research/template/save?id=${id}`
        : `${API_URL}settings/research/template/save`;

      const response = await axios.post(url, formData, config);

      if (response.data.success) {
        showToast.success(response.data.message);
        navigate("/Settings/TemplateResearch");
      }
    } catch (error) {
      console.error("Error saving template:", error);
      showToast.error("There was an error saving the template");
    }
  };

  const handleFieldChange = (e, fieldName) => {
    const value = e.target.value;
    switch (fieldName) {
      case "templateName":
        setTemplateName(value);
        break;
      case "message":
        setMessage(value);
        break;
      case "notificationTitle":
        setNotificationTitle(value);
        break;
      case "notification":
        setNotification(value);
        break;
      case "whatsappCampaign":
        setWhatsappCampaign(value);
        break;
      case "templateType":
        setTemplateType(value);
        break;
      case "wpFileName":
        setWpFileName(value);
        break;
      default:
        break;
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="page-container page-header-fixed page-sidebar-fixed fade in mt-5">
      <div className="panel panel-default with-rounded-corner with-shadow">
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="panel-heading border-0">
            <span className="panel-title">
              {id ? "Edit" : "Add"} Template Research
            </span>
          </div>
          <div className="panel-body">
            <div className="row">
              <div className="col-md-4 mb-2">
                <label>Template Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="templateName"
                  value={templateName}
                  onChange={(e) => handleFieldChange(e, "templateName")}
                  disabled
                />
              </div>

              <div className="col-md-8 mb-2">
                <label>Select Data (Message)</label>
                <StateManagedSelect
                  options={fieldList}
                  onChange={(option) =>
                    option && setMessage((prev) => prev + option.value)
                  }
                />
              </div>

              <div className="col-md-12 mb-2">
                <label>Message</label>
                <textarea
                  className="form-control"
                  name="message"
                  value={message}
                  onChange={(e) => handleFieldChange(e, "message")}
                />
              </div>

              <div className="col-md-8 mb-2">
                <label>Select Data (Notification Title)</label>
                <StateManagedSelect
                  options={fieldList}
                  onChange={(option) =>
                    option &&
                    setNotificationTitle((prev) => prev + option.value)
                  }
                />
              </div>

              <div className="col-md-12 mb-2">
                <label>Push Notification Title</label>
                <textarea
                  className="form-control"
                  name="notificationTitle"
                  value={notificationTitle}
                  onChange={(e) => handleFieldChange(e, "notificationTitle")}
                />
              </div>

              <div className="col-md-8 mb-2">
                <label>Select Data (Notification)</label>
                <StateManagedSelect
                  options={fieldList}
                  onChange={(option) =>
                    option && setNotification((prev) => prev + option.value)
                  }
                />
              </div>

              <div className="col-md-12 mb-2">
                <label>Push Notification</label>
                <textarea
                  className="form-control"
                  name="notification"
                  value={notification}
                  onChange={(e) => handleFieldChange(e, "notification")}
                />
              </div>

              <div className="col-md-4 mb-2">
                <label>Campaign Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="whatsappCampaign"
                  value={whatsappCampaign}
                  onChange={(e) => handleFieldChange(e, "whatsappCampaign")}
                />
              </div>

              <div className="col-md-5 mb-2">
                <label>Template Type</label>
                <select
                  className="form-control"
                  name="templateType"
                  value={templateType}
                  onChange={(e) => handleFieldChange(e, "templateType")}
                >
                  {Object.entries(typeArr).map(([key, value]) => (
                    <option key={key} value={key}>
                      {value}
                    </option>
                  ))}
                </select>
              </div>

              {/* ✅ Image Upload Section */}
              <div className="col-md-6 mb-2">
                <label>Upload Image</label>
                <input
                  type="file"
                  accept="image/*"
                  className="form-control"
                  onChange={(e) => setImageFile(e.target.files[0])}
                />
              </div>

              {oldImageUrl && (
                <div className="col-md-3 mb-2">
                  <label>Old Image Preview</label>
                  <br />
                  <img
                    src={oldImageUrl}
                    alt="Old Image"
                    width="100"
                    className="rounded border"
                  />
                </div>
              )}

              {templateType !== "1" && (
                <div className="row w-100 d-flex gap-2 align-items-end">
                  <div className="col-md-4 mb-2">
                    <label>File Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="wpFileName"
                      value={wpFileName}
                      onChange={(e) => handleFieldChange(e, "wpFileName")}
                    />
                  </div>
                  <div className="col-md-5 mb-2">
                    <label>Upload File</label>
                    <input
                      type="file"
                      name="wp_upload_file"
                      className="form-control"
                      onChange={(e) => setFile(e.target.files[0])}
                    />
                  </div>
                  {oldFileUrl && (
                    <div className="col-md-3">
                      <img src={oldFileUrl} alt="File Preview" width="50px" />
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="row">
              <table className="table">
                <thead>
                  <tr>
                    <th style={{ width: "70%" }}>Field</th>
                    <th style={{ width: "30%" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {paramList.map((param, index) => (
                    <tr key={index}>
                      <td>
                        <StateManagedSelect
                          options={fieldList}
                          value={param}
                          onChange={(selectedOption) =>
                            handleParamChange(selectedOption, index)
                          }
                        />
                      </td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={() => handleDeleteRow(index)}
                        >
                          <i className="fa fa-times" /> Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan="2">
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={handleAddData}
                      >
                        + Add Field
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="col-md-12">
              <SubmitButton
                pageBack={"/Settings/TemplateResearch"}
                handleSubmit={handleSubmit}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TemplateResearchForm;
